// extracted by mini-css-extract-plugin
module.exports = {"root":"SimpleNavPanel_root__7YjWQ","item":"SimpleNavPanel_item__h_pYi","rotation":"SimpleNavPanel_rotation__iGufH"};